export const SENDER_SUCCESS = "SENDER_SUCCES";
export const RECEIVER_SUCCESS = "RECEIVER_SUCCESS";
export const SET_CHATLIST = "SET_CHATLIST";
export const SORT_CHATLIST = "SORT_CHATLIST";
export const CLEAR_CHATLIST = "CLEAR_CHATLIST";
export const SET_ERROR = "SET_ERROR";
export const SET_ERROR_CLEAR = "SET_ERROR_CLEAR";
export const SET_SUCCESS_CLEAR = "SET_SUCCESS_CLEAR";
export const SET_NEWSTATUS = "SET_NEWSTATUS";
export const SENDCHAT_SUCCESS = "SENDCHAT_SUCCESS";
export const RECEIVE_CHAT = "RECEIVE_CHAT";
export const MESSAGE_LIST = "MESSAGE_LIST";
export const CLEAR_MESSAGE = "CLEAR_MESSAGE";
export const ENDCHAT_SUCCESS = "ENDCHAT_SUCCESS";
export const ENDASSIGNED_SUCCESS = "ENDASSIGNED_SUCCESS";
export const ENDCHAT_AUTO = "ENDCHAT_AUTO";
export const CLEAR_CHATSTATE = "CLEAR_CHATSTATE";
export const SET_CHATLIST_READCOUNT = "SET_CHATLIST_READCOUNT";
export const ASSIGNED_AGENT = "ASSIGNED_AGENT";
export const UPDATE_CHAT = "UPDATE_CHAT";
export const UPDATE_CHAT_SINGLE = "UPDATE_CHAT_SINGLE";
export const UPDATE_EMAIL = "UPDATE_EMAIL";
export const UPDATE_CHAT_CONTACT_INFO = "UPDATE_CHAT_CONTACT_INFO";

